// extracted by mini-css-extract-plugin
module.exports = {"overlay_wrapper":"OverlayComponent_overlay_wrapper__183Pz","overlay_wrapper_active":"OverlayComponent_overlay_wrapper_active__1J3jm"};